import { SectionBanner } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';
import { usePlan } from '@melio/subscriptions-api';
import { useSubscription } from '@melio/subscriptions-sdk';

export const AddSeatToSubscriptionBanner = () => {
  const { formatMessage, formatCurrency } = useMelioIntl();
  const { subscription } = useSubscription();
  const { data: plan } = usePlan({ params: { id: subscription.planId } });

  const priceAmount =
    (plan &&
      (subscription.billingCycle === 'monthly' ? plan.billingCycles.monthly.price : plan.billingCycles.yearly.price)) ||
    0;

  const price = formatMessage(
    'activities.manageCollaborators.screens.invitationModal.subscriptions.addUser.pricePerCycle',
    {
      formattedPrice: formatCurrency(priceAmount),
      billingCycle: subscription.billingCycle,
    }
  );

  return plan ? (
    <SectionBanner
      data-testid="add-seat-to-subscription-banner"
      variant="neutral"
      description={formatMessage('activities.manageCollaborators.screens.invitationModal.subscriptions.addUser.info', {
        price,
      })}
    />
  ) : (
    <></>
  );
};
